import React from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

import styles from "../../menu.module.css";

const SubMenuList = ({ items = [] }) => {
  const location = useLocation();

  return (
    <ul className={styles.sub_menu}>
      {items.map((item, index) => {
        const isActive = location.pathname == item?.url;

        return (
          <Link key={index} to={item?.url ?? "/"}>
            <li
              className={`${styles.sub_menu_item} ${
                isActive ? styles.active_sub_item : ""
              }`}
            >
              {item?.name ?? "Untitled"}
            </li>
          </Link>
        );
      })}
    </ul>
  );
};

export default SubMenuList;
